enum RegionEnum {
    Metro = 'METRO',
    MetroHighDensity = 'METRO_HIGH_DENSITY',
    Regional = 'REGIONAL',
    RegionalHighDensity = 'REGIONAL_HIGH_DENSITY',
}

export default RegionEnum;
